const booleanToText = (value) => {
  if (value) {
    return 'yes';
  }

  return 'no';
};

export default booleanToText;
